import React, { useState, useEffect } from "react";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import HeaderData from "./HeaderData";
import Logo from "./Logo";
import { formatCurrency } from "services/util";
import { concat, keys, sumBy, uniq } from "lodash";

export const PayrunSummary = ({
  item,
  t,
  client,
  payroll,
  selectedOrganisation,
  ...props
}) => {
  const [paySlips, setPaySlips] = useState();
  const [earningTypes, setEarningTypes] = useState([]);
  const [settings, setSettings] = useState();
  const { language } = props

  const onMount = async () => {
    const [data, settings] = await Promise.all([
      payroll
        .get("pay_slips", {
          params: {
            pay_run_id: item.id,
          },
        })
        .get("data"),
      payroll.get("settings/1").get("data"),
    ]);
    let earningTypes = [];
    data.map(
      (x) => (earningTypes = concat(earningTypes, keys(x.gross_breakdown)))
    );
    setEarningTypes(uniq(earningTypes));
    setSettings(settings);
    setPaySlips(data);
  };

  useEffect(() => void onMount(), []);

  if (!paySlips) return null;

  return (
    <DocumentRenderer {...props}>
      <div className="container-fluid m-0 p-0">
        <div>
          <Logo value={settings.logo} />
        </div>
        <div className="d-flex justify-content-between mb-5">
          <h1>
            <Trans>Payrun Summary</Trans>
          </h1>
          <p>
            <Trans>Serial Number</Trans>: {item.serial_number}
          </p>
        </div>
        <div>
          <div className="mr-4">
            <HeaderData
              className="mb-1"
              label="Period"
              value={`${item.start_date} - ${item.end_date}`}
            />
          </div>
        </div>

        <table className="table table-striped employee-holiday-table">
          <thead>
            <tr>
              <th className="font-weight-bold p-2">
                <Trans>Employee</Trans>
              </th>
              {earningTypes.map((x) => (
                <th className="font-weight-bold p-2" key={x}>
                  <Trans>{x}</Trans>
                </th>
              ))}
              <th className="font-weight-bold p-2">
                <Trans>Allowances</Trans>
              </th>
              <th className="font-weight-bold p-2">
                <Trans>Reimbursements</Trans>
              </th>
              <th className="font-weight-bold p-2">
                <Trans>Deductions</Trans>
              </th>
              <th className="font-weight-bold p-2">
                <Trans>Tax</Trans>
              </th>
              <th className="font-weight-bold p-2">
                <Trans>Net</Trans>
              </th>
            </tr>
          </thead>
          <tbody className="small">
            {paySlips.map((i) => (
              <tr key={i.id}>
                <td className="p-2">{i.full_name}</td>
                {earningTypes.map((x) => (
                  <td className="p-2" key={x}>
                    {formatCurrency(i.gross_breakdown[x])}
                  </td>
                ))}
                <td className="p-2">{formatCurrency(i.total_allowances)}</td>
                <td className="p-2">
                  {formatCurrency(i.total_reimbursements)}
                </td>
                <td className="p-2">{formatCurrency(i.total_deductions)}</td>
                <td className="p-2">{formatCurrency(i.total_tax)}</td>
                <td className="p-2">{formatCurrency(i.net_pay)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot className="small">
            <tr>
              <td />
              {earningTypes.map((x) => (
                <td className="p-2" key={x}>
                  {formatCurrency(sumBy(paySlips, (p) => p.gross_breakdown[x]))}
                </td>
              ))}
              <td className="p-2 font-weight-semibold">
                {formatCurrency(item.total_allowances)}
              </td>
              <td className="p-2 font-weight-semibold">
                {formatCurrency(item.total_reimbursements)}
              </td>
              <td className="p-2 font-weight-semibold">
                {formatCurrency(item.total_deductions)}
              </td>
              <td className="p-2 font-weight-semibold">
                {formatCurrency(item.total_tax)}
              </td>
              <td className="p-2 font-weight-semibold">
                {formatCurrency(item.total_pay)}
              </td>
            </tr>
          </tfoot>
        </table>
        <hr />
        <table>
          <tr>
            <td>
              <h4>
                <Trans>Signature</Trans>:
              </h4>
              <div
                className="border-bottom border-dark d-inline-block"
                style={{ width: "20rem", marginTop: "4rem", height: "1px" }}
              />
            </td>
            <td style={{ paddingLeft: "50px", paddingRight: "50px" }}>
              <h4>
                <Trans>Signature</Trans>:
              </h4>
              <div
                className="border-bottom border-dark d-inline-block"
                style={{ width: "20rem", marginTop: "4rem", height: "1px" }}
              />
            </td>
          </tr>
        </table>
      </div>
    </DocumentRenderer>
  );
};

export default PayrunSummary;
